module.exports = __webpack_public_path__ + "img/slider_banner_2(old).2947b6dc.jpg";